import { useHistory, useParams } from "react-router-dom";
import React from "react";

import { AccountsParams } from "./types";
import { useAuth } from "@hubcapp/context";
import Accounts from "./Accounts";

const AccountsStateProvider: React.FC = ({}) => {
  const { selectedTab = "transactions" } = useParams<AccountsParams>();
  const history = useHistory();
  const {
    instructor: { id: instructorId },
  } = useAuth();

  const onSelectTab = (newValue: string) => {
    if (newValue === "accounts") return history.push("/accounts");
    return history.push(`/accounts/${newValue}`);
  };

  return (
    <Accounts
      onSelectTab={onSelectTab}
      instructorId={instructorId}
      selectedTab={selectedTab}
    />
  );
};

export default AccountsStateProvider;
